import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock, Unlock, Loader2, ShieldCheck } from "lucide-react";

export const SendLockBanner = ({ locked, onChange }) => {
  const [busy, setBusy] = useState(false);

  const toggle = async () => {
    setBusy(true);
    try {
      if (locked) {
        await api.unlockSending();
        toast.success("Sending unlocked — approved outbound can now go out.");
      } else {
        await api.lockSending();
        toast.success("Sending locked — KURT will draft and queue, but send nothing.");
      }
      onChange && (await onChange());
    } catch {
      toast.error("Couldn't change the send lock.");
    } finally {
      setBusy(false);
    }
  };

  if (locked) {
    return (
      <div data-testid="send-lock-banner" className="max-w-6xl mx-auto mb-6 rounded-2xl border border-amber-500/25 bg-amber-500/[0.07] px-5 py-4 flex items-center justify-between gap-4 flex-wrap kz-fade-up">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center w-9 h-9 rounded-full bg-amber-500/15 text-amber-300"><Lock size={17} /></span>
          <div>
            <p className="text-sm font-bold text-amber-200">Send lock is ON — nothing is going out.</p>
            <p className="text-xs text-amber-200/70 mt-0.5">KURT keeps researching, drafting and queueing everything for your approval, but no email, follow-up or studio hand-off is sent until you unlock.</p>
          </div>
        </div>
        <button data-testid="unlock-sending-btn" onClick={toggle} disabled={busy}
          className="shrink-0 flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500 text-[#231a00] font-semibold text-sm hover:bg-amber-400 disabled:opacity-60 transition-all">
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Unlock size={15} />} Unlock sending
        </button>
      </div>
    );
  }

  return (
    <div data-testid="send-live-banner" className="max-w-6xl mx-auto mb-6 rounded-2xl border border-emerald-500/25 bg-emerald-500/[0.06] px-5 py-3 flex items-center justify-between gap-4 flex-wrap kz-fade-up">
      <div className="flex items-center gap-3">
        <span className="grid place-items-center w-8 h-8 rounded-full bg-emerald-500/15 text-emerald-300"><ShieldCheck size={16} /></span>
        <p className="text-sm font-semibold text-emerald-200">Sending is LIVE — approved outbound will be sent for real.</p>
      </div>
      <button data-testid="lock-sending-btn" onClick={toggle} disabled={busy}
        className="shrink-0 flex items-center gap-2 px-4 py-2 rounded-full bg-white/[0.06] text-slate-100 font-semibold text-sm hover:bg-white/[0.1] disabled:opacity-60 transition-all">
        {busy ? <Loader2 size={15} className="animate-spin" /> : <Lock size={15} />} Lock sending
      </button>
    </div>
  );
};
